import React from 'react';
import Typography from '@material-ui/core/Typography';

const EmptyFieldPlaceholder = ({ record, source }) => {
    if (!record) return null
    return (<Typography variant="body1" color="textSecondary" noWrap>{record[source]}</Typography>);
}

export default EmptyFieldPlaceholder;